import { render, staticRenderFns } from "./usrheader.vue?vue&type=template&id=08317415&scoped=true"
import script from "./usrheader.vue?vue&type=script&lang=js"
export * from "./usrheader.vue?vue&type=script&lang=js"
import style0 from "./usrheader.vue?vue&type=style&index=0&id=08317415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08317415",
  null
  
)

export default component.exports